enum ResourceType {
  DOWNLOADABLE = "downloadable",
	SETTINGS = "settings",
  OTHER = "other",
}

// eslint-disable-next-line no-redeclare
namespace ResourceType {
  export const names = {
    [ResourceType.DOWNLOADABLE]: "Downloadable",
		[ResourceType.SETTINGS]: "Settings",
    [ResourceType.OTHER]: "Other",
  } as any;

  export const display = (type: ResourceType) => names[type];

  export const defaultValue = ResourceType.OTHER;
}

export { ResourceType };
